export default __webpack_public_path__ + "dd471a69cad70b2bbcf240adcc417628.svg";